import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/flows")({
  component: FlowsRoute,
});

function FlowsRoute() {
  return (
    <div>
      <h1 className="text-2xl font-bold mb-4">Flows</h1>
      <p className="text-muted-foreground">Workflow flows coming soon...</p>
    </div>
  );
}
